'use strict';

const root = "_root_oglih_1";
const inputField = "_input-field_oglih_16";
const ctaDisclaimer = "_cta-disclaimer_oglih_30";
const styles = {
	root: root,
	inputField: inputField,
	ctaDisclaimer: ctaDisclaimer
};

exports.styles = styles;
//# sourceMappingURL=SubscriptionForm.module-CQEDilRD.js.map
